const reportTypeStrategyOptions = [
  {
    label: 'Cultural Calendar',
    value: 'cultural_calendar',
    description: 'Cultural Calendar.',
  },
  {
    label: 'Relevant Formats',
    value: 'relevant_formats',
    description: 'Relevant Formats.',
  },
  {
    label: 'Hot Topics',
    value: 'hot_topics',
    description: 'Hot Topics.',
  },
  {
    label: 'Trending Creators',
    value: 'trending_creators',
    description: 'Trending Creators.',
  },
]

export default reportTypeStrategyOptions
